import { APPLICABILITY_RULES, STATE_RANK } from '../../data/regulations/applicabilityRules'
import type { ApplicabilityMatch, ApplicabilityState, CompanyProfile, RegulatoryRecord } from '../../data/regulations/types'

export function evaluateApplicability(records: RegulatoryRecord[], profile: CompanyProfile): ApplicabilityMatch[] {
  return records.map((record) => {
    const matched = APPLICABILITY_RULES.filter((rule) => rule.recordId === record.id && rule.when(profile))
    if (!matched.length) {
      return {
        recordId: record.id,
        state: 'no_trigger_identified' as ApplicabilityState,
        obligationLevel: record.obligationLevel,
        reasons: [
          'No company attribute in the supplied profile triggered this record. That is not a legal conclusion that the instrument cannot apply.',
        ],
        triggeredBy: [],
        unverified: [],
        ruleIds: [],
        sourceUrls: record.officialSources.map((source) => source.url),
      }
    }
    const strongest = matched.reduce((best, rule) => (STATE_RANK[rule.state] > STATE_RANK[best.state] ? rule : best))
    const unverified = [...new Set(matched.flatMap((rule) => rule.unverified))]
    return {
      recordId: record.id,
      state: strongest.state,
      obligationLevel: record.obligationLevel,
      reasons: matched.map((rule) => rule.because),
      triggeredBy: [...new Set(matched.flatMap((rule) => rule.triggeredBy))],
      unverified,
      ruleIds: matched.map((rule) => rule.id),
      sourceUrls: record.officialSources.map((source) => source.url),
    }
  })
}

export function isActionable(state: ApplicabilityState): boolean {
  return state !== 'no_trigger_identified'
}

export const APPLICABILITY_LABELS: Record<ApplicabilityState, string> = {
  potentially_relevant: 'Potentially relevant',
  likely_relevant: 'Likely relevant based on supplied information',
  further_verification_required: 'Further verification required',
  no_trigger_identified: 'No trigger identified from supplied information',
  voluntary_or_market_driven: 'Voluntary or market-driven consideration',
}
